var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7701 6.21041C11.7718 6.89566 11.6117 7.57165 11.3028 8.1833C10.9365 8.91625 10.3733 9.53274 9.67643 9.96372C8.97954 10.3947 8.17641 10.6231 7.35702 10.6235C6.67177 10.6252 5.99579 10.4651 5.38413 10.1562L2.4248 11.1426L3.41125 8.1833C3.1023 7.57165 2.9422 6.89566 2.94399 6.21041C2.9443 5.39102 3.17274 4.5879 3.60372 3.891C4.03469 3.1941 4.65118 2.63096 5.38413 2.26464C5.99579 1.95569 6.67177 1.79559 7.35702 1.79738H7.61661C8.69876 1.85708 9.72087 2.31384 10.4872 3.0802C11.2536 3.84656 11.7104 4.86867 11.7701 5.95082V6.21041Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMessageCircleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircleWhite);
export default __webpack_public_path__ + "static/media/MessageCircleWhite.d49c458b.svg";
export { ForwardRef as ReactComponent };